module.exports = __webpack_public_path__ + "img/previous.a42894c9.svg";